import { Drawer } from "antd";
import styled from "styled-components";

export const CustomDrawer = styled(Drawer)``;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
`;

export const ContentWrapper = styled.div`
  height: 192px;
  margin: 80px auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  text-align: center;
`;

export const ContainerTitle = styled.div`
  width: 320px;
  height: 192px;
  top: 80px;
  left: 80px;
  gap: 16px;
  text-align: start;
`;

export const Title = styled.h2`
  font-size: 32px;
  font-weight: 300;
  line-height: 40px;
  letter-spacing: -1%;

  strong {
    font-weight: 700;
  }
`;

export const Description = styled.p`
  font-size: 16px;
  color: #99aabb;
  line-height: 24px;
  letter-spacing: 0%;
  font-weight: 400;
`;

export const QRCodeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 2px solid #ecf0f6;
  background-color: #ecf0f6;
`;

